import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { EmailWaitingConfirm } from './email-waiting-confirm';

const WrapAuth = withAuth(EmailWaitingConfirm);
const WrappedEmailWaitingConfirm = withLayout(LayoutType.Empty, WrapAuth);

export { WrappedEmailWaitingConfirm as EmailWaitingConfirm };
